export const PLAYER_STRENGTH_OPTIONS = [
  'Pattern Play',
  'Cue-Ball Control',
  'Safety Play',
  'Break & Run',
  'Banks & Kicks',
  'Long Potting',
  'Mental Game',
  'Jump/Massé',
  'Speed Control',
  'Cluster Management',
];

export const PLAYER_SOCIAL_PLATFORMS = [
  {
    field: 'instagramUrl',
    label: 'Instagram',
    placeholder: 'https://www.instagram.com/username',
    hosts: ['instagram.com', 'www.instagram.com'],
  },
  {
    field: 'tiktokUrl',
    label: 'TikTok',
    placeholder: 'https://www.tiktok.com/@username',
    hosts: ['tiktok.com', 'www.tiktok.com', 'm.tiktok.com'],
  },
  {
    field: 'youtubeUrl',
    label: 'YouTube',
    placeholder: 'https://youtube.com/@channel',
    hosts: ['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtu.be'],
  },
  {
    field: 'facebookUrl',
    label: 'Facebook',
    placeholder: 'https://www.facebook.com/username',
    hosts: ['facebook.com', 'www.facebook.com', 'm.facebook.com', 'fb.com', 'www.fb.com'],
  },
  {
    field: 'xUrl',
    label: 'X',
    placeholder: 'https://x.com/username',
    hosts: ['x.com', 'www.x.com', 'twitter.com', 'www.twitter.com', 'mobile.twitter.com'],
  },
  {
    field: 'threadsUrl',
    label: 'Threads',
    placeholder: 'https://www.threads.net/@username',
    hosts: ['threads.net', 'www.threads.net'],
  },
  {
    field: 'snapchatUrl',
    label: 'Snapchat',
    placeholder: 'https://www.snapchat.com/add/username',
    hosts: ['snapchat.com', 'www.snapchat.com'],
  },
  {
    field: 'linkedinUrl',
    label: 'LinkedIn',
    placeholder: 'https://www.linkedin.com/in/username',
    hosts: ['linkedin.com', 'www.linkedin.com'],
  },
  {
    field: 'twitchUrl',
    label: 'Twitch',
    placeholder: 'https://www.twitch.tv/channel',
    hosts: ['twitch.tv', 'www.twitch.tv'],
  },
  {
    field: 'discordUrl',
    label: 'Discord',
    placeholder: 'https://discord.gg/invite',
    hosts: ['discord.gg', 'www.discord.gg', 'discord.com', 'www.discord.com'],
  },
  {
    field: 'redditUrl',
    label: 'Reddit',
    placeholder: 'https://www.reddit.com/user/username',
    hosts: ['reddit.com', 'www.reddit.com', 'old.reddit.com', 'new.reddit.com'],
  },
  {
    field: 'pinterestUrl',
    label: 'Pinterest',
    placeholder: 'https://www.pinterest.com/username',
    hosts: ['pinterest.com', 'www.pinterest.com'],
  },
];

export function emptySocialLinks() {
  return PLAYER_SOCIAL_PLATFORMS.reduce((out, platform) => {
    out[platform.field] = '';
    return out;
  }, {});
}

export function normalizeP4RUrl(input) {
  const trimmed = String(input || '').trim();
  if (!trimmed) return '';
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}

export function validateOfficialSocialLink(platform, input) {
  const normalized = normalizeP4RUrl(input);
  if (!normalized) return true;

  try {
    const url = new URL(normalized);
    const host = url.hostname.toLowerCase().replace(/\.$/, '');
    return url.protocol === 'https:' && platform.hosts.includes(host);
  } catch {
    return false;
  }
}

export function nicknameWords(nickname) {
  const words = String(nickname || '')
    .toLowerCase()
    .split(/\s+/)
    .map((word) => word.trim())
    .filter(Boolean);

  const out = new Set();
  words.forEach((word) => {
    if (word.length < 2) {
      out.add(word);
      return;
    }

    for (let i = 0; i < word.length; i += 1) {
      for (let j = i + 1; j <= word.length; j += 1) {
        const sub = word.slice(i, j);
        if (sub.length >= 2) out.add(sub);
      }
    }
  });

  return Array.from(out).slice(0, 240);
}

export function profileMissingFields({ nickname, bio, profileImageUrl }) {
  const missing = [];
  if (!String(nickname || '').trim()) missing.push('nickname');
  if (!String(bio || '').trim()) missing.push('bio');
  if (!String(profileImageUrl || '').trim()) missing.push('profileImageUrl');
  return missing;
}
